import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaEnvelope, FaPhone,FaUserTie } from 'react-icons/fa';
import api from '../services/api';
import { getMediaUrl } from '../services/api';
import './Officers.css';


const Officers = () => {
  const [officers, setOfficers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadOfficers();
  }, []);

  const loadOfficers = async () => {
    try {
      const response = await api.get('/officers/');
      const officersData = response.data.results || response.data;
      setOfficers(Array.isArray(officersData) ? officersData : []);
    } catch (error) {
      console.error('Error loading officers:', error);
      setOfficers([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <h1 className="page-title mb-2">Our Officers</h1>
      <p className="text-muted mb-4 text-center">
        Meet the key officials managing various departments
      </p>

      <Row className="justify-content-center">
        {officers.map((officer) => (
          <Col key={officer.id} lg={3} md={4} sm={6} className="mb-4">
            <Card className="officer-card h-100 shadow-sm">
              {officer.photo ? (
                <Card.Img
                  variant="top"
                  src={getMediaUrl(officer.photo)}
                  alt={officer.name}
                  className="officer-photo"
                />
              ) : (
                <div className="officer-photo-placeholder">
                  <FaUserTie size={80} />
                </div>
              )}
              <Card.Body>
                <Card.Title className="officer-name">{officer.name}</Card.Title>
                <Card.Subtitle className="mb-2 text-muted officer-designation">
                  {officer.designation}
                </Card.Subtitle>
                {officer.department && (
                  <p className="officer-department mb-2">
                    <strong>Dept:</strong> {officer.department_name || "-"}
                  </p>
                )}
                {officer.email && (
                  <p className="officer-contact mb-1">
                    <FaEnvelope className="me-2" /> {officer.email}
                  </p>
                )}
                {officer.phone && (
                  <p className="officer-contact mb-0">
                    <FaPhone className="me-2" /> {officer.phone}
                  </p>
                )}
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>


      {officers.length === 0 && (
        <div className="text-center py-5">
          <p className="text-muted">No officers information available at this time.</p>
        </div>
      )}
    </Container>
  );
};

export default Officers;
